/*
 * @Author: caizexin caizexin@kjgb.net
 * @Date: 2026-08-11
 */
import { Data } from '@/api/axiosFun.js';
import axios from 'axios';

// 文件资源服务基础URL
// const RESOURCE_BASE_URL = 'https://sit-ota.gobao-ebike.com/ota/resources/v1/mcu'

class FileApi {
    static getInstance() {
        if (!this.instance) this.instance = new FileApi()
        return this.instance
    }

    // 获取数据（通用，走 /api 代理）
    async getData(url, param, method, dataType) {
        let result = await Data.getInstance().getData(url, param, method, dataType)
        return result
    }

    // 上传文件 — category: 'pictures' | 'files'
    async uploadFile(formData) {
        let url = `/api/v1/page/resources/file/upload`
        let result = await this.getData(url, formData, 'POST', 'multipart/form-data')
        return result
    }

    // 文件类目列表
    async getCategoryList(formData) {
        let url = `/api/v1/page/resources/file/category/list`
        let result = await this.getData(url, formData, 'GET', 'application/json;charset=utf-8')
        return result
    }
    // 文件下载
    async fileDownload(file_no) {
        let url = `/api/v1/page/resources/file/${file_no}`
        let result = await this.getData(url, {}, 'GET', 'application/octet-stream')
        return result
    }
    // 文件删除
    async fileDelete(file_no) {
        let url = `/api/v1/page/resources/file/${file_no}`
        let result = await this.getData(url, {}, 'DELETE', 'application/json;charset=utf-8')
        return result
    }

    /**
     * 获取文件列表（直连资源服务，不走 /api 代理）
     * @param {Object} param - { app_id, sign, page_no, page_size, cateItem, t }
     */
    // async getFileList(param) {
    //     let queryParts = []
    //     for (let key in param) {
    //         if (param[key] !== '' && param[key] !== undefined && param[key] !== null) {
    //             queryParts.push(`${key}=${encodeURIComponent(param[key])}`)
    //         }
    //     }
    //     let url = `${RESOURCE_BASE_URL}/file-list?${queryParts.join('&')}`

    //     let token = localStorage.getItem('hd_ota_token')
    //     let config = {
    //         headers: {
    //             'Content-Type': 'application/json;charset=utf-8',
    //             'Authorization': token == null ? '' : 'Bearer ' + token,
    //         },
    //         method: 'GET',
    //         timeout: 60 * 1000,
    //         url: url,
    //     }

    //     return new Promise((resolve, reject) => {
    //         axios(config).then(res => {
    //             resolve(res.data)
    //         }).catch(error => {
    //             console.log(error, 'getFileList error')
    //             reject(error)
    //         })
    //     })
    // }

    async getFileList(param) {
        let url = `/api/v1/page/resources/file/page`
        let result = await this.getData(url, param , 'GET', 'application/json;charset=utf-8')
        return result
    }

    /**
     * 生成签名（TODO：待对接签名算法）
     * @param {Object} param - 签名参数
     * @returns {string} 签名字符串
     */
    generateSign(param) {
        // TODO: 实现签名算法
        // 预期参数：app_id, t 等，使用约定的密钥和算法（如 MD5/HMAC-SHA256）生成签名
        return 'TODO_SIGN_PLACEHOLDER'
    }

    // 预留：删除文件
    // async deleteFile(id) {
    //     let url = `/api/v1/page/file/${id}`
    //     let result = await this.getData(url, {}, 'DELETE')
    //     return result
    // }
}

export {
    FileApi
}
